import { BaseModel } from '@Core';

export enum StreamType {
    PrimaryStream,
    SecondaryStream,
    TertiaryStream,
    FourthStream,
    FifthStream,
}

export interface ScheduleItem {
    ScheduleIndex: number;
    Schedule: string;
}

export interface PTZRecordSetting extends BaseModel {
    DevMac: string;
    RecycleStorageEnable: number;
    PreRecordTime: number;
    StreamType: StreamType;
    ScheduleList: ScheduleItem[];
}
